export default "__VITE_ASSET__e2249875__"